import React, { FC } from "react";
import { Pagination as MuiPagination, PaginationProps } from "@mui/material";

const Pagination: FC<PaginationProps> = (props) => <MuiPagination {...props} />;

export default Pagination;
